import service from '@/services/search';
import { SearchResponse } from '@/services/search/queries';
import { IPage, PaginationRequest } from '@/services/gql/generic-find';
import { debounceSearch } from '@/store/utils';

interface SearchState extends PaginationRequest  {
  loadSeeds: number[];
  history: string[];
  result: SearchResponse[];
}

export default {
  namespaced: true,
  state: {
    history: service.getHistory(),
    loadSeeds: [],
    page: {
      number: 1,
      query: {
        value: '',
      },
      recordCount: 0,
      size: 10,
    },
    result: [],
  } as SearchState,
  getters: {
    isSearchLoading: (state: SearchState) => !!state.loadSeeds.length,
  },
  mutations: {
    LOAD(state: SearchState, data: SearchResponse[] = []) {
      state.result = data;
    },
    LOAD_SEED_ADD(state: SearchState, seed: number) {
      state.loadSeeds = state.loadSeeds.concat(seed);
    },
    LOAD_SEED_CLEAR(state: SearchState) {
      state.loadSeeds = [];
    },
    LOAD_SEED_REMOVE(state: SearchState, seed: number) {
      state.loadSeeds = state.loadSeeds.filter(loadSeed => loadSeed !== seed);
    },
    UPDATE_HISTORY(state: SearchState, history: string[] = []) {
      state.history = history;
    },
    UPDATE_PAGE(state: SearchState, payload: any) {
      state.page = {
        ...state.page,
        ...payload,
      };
    },
  },
  actions: {
    addToHistory: ({ commit }: any, value: string) => {
      commit('UPDATE_HISTORY', service.addToHistory(value));
    },
    clearSearch: ({ commit }: any) => {
      service.clearHistory();
      commit('LOAD', []);
      commit('UPDATE_HISTORY', []);
      commit('UPDATE_PAGE', {
        query: {
          value: '',
        },
      });
    },
    request: ({ commit, state }: any, page: IPage) => {
      const value = page.query && page.query.value;

      // run load debounced
      return value && debounceSearch({
        commit,
        page,
        service,
        state,
        onSearch: (pageParams: any) => (
          service.request(value, pageParams)
        ),
      });
    },
  },
};
